import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/de'
import 'dayjs/locale/en'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'

dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(isBetween)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(weekOfYear)
dayjs.extend(quarterOfYear)

// Locale Mapping (Vue i18n → Day.js)
const localeMap = {
  'de-DE': 'de',
  'en-GB': 'en',
  'fr-FR': 'fr',
  'it-IT': 'it'
}

export default {
  install: (app) => {
    app.config.globalProperties.$dayjs = dayjs
    app.provide('dayjs', dayjs)

    // ✅ Sync mit i18n Locale
    const i18n = app.config.globalProperties.$i18n
    if (i18n) {
      dayjs.locale(localeMap[i18n.locale] || 'de')

      // Watch locale changes
      app.config.globalProperties.$watch(
        () => i18n.locale,
        (newLocale) => {
          dayjs.locale(localeMap[newLocale] || 'de')
        }
      )
    }
  }
}

export { dayjs }
